import React from 'react';
export const Paginator = (props) => {
    function clickHandler(e) {
        e.preventDefault();
        const target = e.target;
        if (+target.dataset.page !== props.page) {
            props.updatePage(parseInt(target.dataset.page));
        }
    }
    let current = props.page;
    let start = 1;
    let end = props.pagination.totalPages;
    if (end - current < 2 && end > 5) {
        start = end - 4;
    }
    else if (current > 3) {
        start = current - 2;
        end = end > (current + 2) ? current + 2 : end;
    }
    else {
        end = Math.min(end, 5);
    }
    let prev = Math.max(1, (current - 1));
    let next = Math.min(end, (current + 1));
    let range = [];
    for (let i = start; i <= end; i++) {
        range.push(React.createElement("a", { href: `?page=${i}`, "data-page": i, key: i, className: "hidden md:block px-2 " + (current === i ? 'font-bold' : '') }, i));
    }
    return (React.createElement("div", { className: "min-w-[220px]", onClick: clickHandler },
        React.createElement("div", { className: "pages flex justify-between" },
            range,
            current > 1 ?
                React.createElement("a", { href: `?page=${prev}`, "data-page": prev, "aria-label": "Prev page", className: "px-2" }, "\u276E")
                :
                    React.createElement("span", { className: "px-2 opacity-50" }, "\u276E"),
            React.createElement("div", { className: "md:hidden" },
                "Page ",
                current),
            current < end ?
                React.createElement("a", { href: `?page=${next}`, "data-page": next, "aria-label": "last page", className: "px-2" }, "\u276F")
                :
                    React.createElement("span", { className: "px-2 opacity-50" }, "\u276F"))));
};
export const ResultCount = (props) => {
    let result = props.pagination.entryTotal > 1 ? "results" : "result";
    if (props.pagination.entryTotal == 0) {
        return (React.createElement("div", { className: "result-count " + props.className }, "No results"));
    }
    return (React.createElement("div", { className: "result-count " + props.className },
        props.pagination.first,
        "-",
        props.pagination.last,
        " of ",
        props.pagination.entryTotal,
        " ",
        result));
};
